import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './HeatmapAlert.css';

export function HeatmapAlert({ visible, onClose }) {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <div className="heatmap-alert">
      <div className="heatmap-alert__icon">
        <AlertTriangle size={16} />
      </div>
      <div className="heatmap-alert__content">
        <div className="heatmap-alert__title">{t('map.heatmapAlert.title')}</div>
        <div className="heatmap-alert__message">{t('map.heatmapAlert.message')}</div>
      </div>
      {onClose && (
        <button 
          className="heatmap-alert__close"
          onClick={onClose}
          aria-label={t('map.heatmapAlert.closeAria')}
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}

